<template>
  <div>
    <span>{{$t('common.statement-of-costs')}}</span>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="costStatement.items"
      hide-default-footer
      mobile-breakpoint="1"
      :items-per-page="1000"
    >
      <template v-slot:item.description="{ item }">
        <span>{{item.description}}</span>
      </template>
      <template v-slot:item.cost="{ item }">
        <coins-widget :amount="item.cost"/>
      </template>
    </v-data-table>
    <v-container>
      <v-row>
        <v-col cols="12" class="text-right">
        {{$t('statement-of-costs.sum')}}: <coins-widget :amount="costSum"/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import commonMixin from "@/mixins/commonMixin";
import CoinsWidget from '@/widgets/CoinsWidget.vue';

export default {
  name: "CoinCostStatement",
  mixins: [commonMixin],
  components: {CoinsWidget},
  props: {
    costStatement: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      headers: [
        {
          text: this.$t('common.description'),
          sortable: false,
          value: "description"
        },
        {
          text: this.$t('common.costs'),
          align: "right",
          sortable: false,
          value: "cost",
        },
      ]
    };
  },
  computed: {
    costSum: function() {
      let ret = 0;
      this.costStatement.items.forEach(item => {
        ret += item.cost;
      });
      return ret;
    }
  },
  methods: {
  }
};
</script>

<style scoped>
</style>